/* eslint-disable max-classes-per-file */
import Resources from "shared/actions/resourcesActions";

// eslint-disable-next-line import/prefer-default-export
export class ExternalSalesPartnerResource extends Resources {
  constructor(dispatch, projectId) {
    super(
      dispatch,
      "external_sales_partner",
      `/api/v1/projects/${projectId}/external_sales_partners`
    );
  }
}
